// utils/attendanceUtils.js
import dayjs from "dayjs";
// !!!!
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);

const arabicDays = [
  "الأحد",     // Sunday (0)
  "الإثنين",   // Monday (1)
  "الثلاثاء",  // Tuesday (2)
  "الأربعاء",  // Wednesday (3)
  "الخميس",    // Thursday (4)
  "الجمعة",    // Friday (5)
  "السبت",     // Saturday (6)
];

export const generateMonthDates = (date) => {
  const daysInMonth = date.daysInMonth();
  const dates = [];
  for (let day = 1; day <= daysInMonth; day++) {
    const fullDate = date.date(day).format("YYYY-MM-DD");
    dates.push(fullDate);
  }
  return dates;
};

export const mapAttendanceRows = (dates, rows, acceptedLeave) => {
  return dates.map((date) => {
    // const match = rows.find(
    //   (row) => dayjs(row.datein).isValid() && dayjs(row.datein).format("YYYY-MM-DD") === date
    // );
    // !!!! replace "/" with "-"
      const match = rows.find((row) => {
            const rowDate = row.datein.replace(/\//g, "-").slice(0, 10);
            return rowDate === date;
          });

    const clean = (value) => (value && value !== "N/A" ? value : "");

    const day = dayjs(date).day();
    const day_arabic = arabicDays[day];
    const isWeekend = day === 0 || day === 6;

    const time = clean(match?.timein);
    const address = clean(match?.addressin)?.replace(/\s*\((?:IN|OUT)\)\s*/gi, " ").trim();

    let status = match?.status || "Pending";
    let isLeave = false;

    if (isWeekend) status = "Weekend";
    else if (!time) status = "";

    const leaveMatch = acceptedLeave.find(
      (leave) => dayjs(date).isBetween(leave.FromDate, leave.ToDate, "day", "[]")
    );

    if (leaveMatch) {
      status = leaveMatch.LeaveTypeDesc;
      isLeave = true;
    }

    return {
      id: date,
      date,
      day_arabic,
      time,
      address,
      status,
      isLeave,
    };
  });
};

// export const calculateTotalHours = (rows) => {
//   return rows.reduce((sum, row) => {
//     const timeRanges = row.time.split("~").map((s) => s.trim());

//     if (timeRanges.length !== 2) return sum;
//     if (timeRanges[0] === "00:00" && timeRanges[1] === "00:00") return sum + 8;

//     const start = dayjs(`2025-01-01 ${timeRanges[0]}`);
//     const end = dayjs(`2025-01-01 ${timeRanges[1]}`);
//     const diff = end.diff(start, "minute");

//     return sum + (diff > 0 ? diff / 60 : 0);
//   }, 0);
// };
// !!!!!

export const calculateTotalHours = (rows) => {
  return rows.reduce((sum, row) => {
    if (!row.time) return sum;
    if (row.status === "Weekend") return sum;

    const rawTime = String(row.time).trim();

    // ── NEW: tagged format "W:08:00 ~ 09:00,L:09:00 ~ 16:00" ──────
    const hasTaggedSegments =
      rawTime.includes("W:") || rawTime.includes("L:");

    if (hasTaggedSegments) {
      // Split by comma to get each segment
      const segments = rawTime.split(",").map((s) => s.trim()).filter(Boolean);

      let workMin = 0;

      for (const seg of segments) {
        // Only process work segments, skip leave segments
        if (seg.startsWith("L:")) {
          console.log(`  => LEAVE segment skipped: ${seg}`);
          continue;
        }

        // Strip "W:" prefix
        const timeStr = seg.startsWith("W:") ? seg.slice(2) : seg;
        const parts = timeStr.split("~").map((s) => s.trim());

        if (parts.length !== 2) continue;

        const toMin = (hhmm) => {
          const [h, m] = hhmm.split(":").map(Number);
          if (isNaN(h)) return null;
          return h * 60 + (m || 0);
        };

        const start = toMin(parts[0]);
        const end = toMin(parts[1]);

        if (start === null || end === null) continue;

        // 00:00 ~ 00:00 shorthand = 8 hours
        if (start === 0 && end === 0) {
          workMin += 480;
          console.log(`  => W shorthand 8h`);
          continue;
        }

        const diff = end - start;
        if (diff > 0) {
          workMin += diff;
          console.log(`  => W: ${parts[0]}~${parts[1]} = ${diff}min`);
        }
      }

      console.log(
        `[hours] date=${row.date} | tagged | workMin=${workMin} (${(workMin / 60).toFixed(2)}h)`
      );
      return sum + workMin / 60;
    }

    // ── LEGACY: old flat format (no tags) ─────────────────────────
    // Keep old logic as fallback for cached/old data
    const tokens = rawTime
      .split(/[~,]/)
      .map((s) => s.trim())
      .filter(Boolean);

    console.log(
      `[hours] date=${row.date} | status="${row.status}" | time="${row.time}" | tokens:`,
      tokens
    );

    const isVacationStatus =
      typeof row.status === "string" && row.status.startsWith("Vacation");

    if (isVacationStatus && tokens.length === 2) {
      console.log("  => pure vacation day, skip");
      return sum;
    }

    if (tokens.length < 2) return sum;

    if (tokens.length === 2 && tokens[0] === "00:00" && tokens[1] === "00:00") {
      return sum + 8;
    }

    const toMin = (hhmm) => {
      const parts = String(hhmm).split(":");
      const h = parseInt(parts[0], 10);
      const m = parseInt(parts[1] || "0", 10);
      if (isNaN(h) || isNaN(m)) return null;
      return h * 60 + m;
    };

    const rawMins = tokens.map(toMin).filter((v) => v !== null);
    if (rawMins.length < 2) return sum;

    rawMins.sort((a, b) => a - b);
    const mins = rawMins.filter((v, i) => i === 0 || v !== rawMins[i - 1]);

    if (mins.length < 2) return sum;
    if (mins.length === 2) {
      return sum + (mins[1] - mins[0]) / 60;
    }

    const outerSpan = mins[mins.length - 1] - mins[0];
    const inner = mins.slice(1, mins.length - 1);
    let leaveMin = 0;
    for (let i = 0; i + 1 < inner.length; i += 2) {
      leaveMin += inner[i + 1] - inner[i];
    }
    const workMin = outerSpan - leaveMin;
    return sum + (workMin > 0 ? workMin / 60 : 0);

  }, 0);
};
